$(document).ready(function () {
  let p = $("body").attr("p");
  let a = $("body").attr("a");
  

  if(p === 'organizer_location_product'){
    let locationId = $("body").attr("event_id");
    let organizerId = $("body").attr("organizer_id");

    $('select').select2({theme: 'bootstrap4',width:"50%"});

    $(document).on('click','#location-product-link-register-button',function(e){
        e.preventDefault()
        const productId = $(".location-product-select").val();
        
        $.ajax({
        type: "POST",
        url: "/api/v1/private/organizer-location-product/add-product",
        data: { location_id: locationId,product_id:productId },
      })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $('select').select2('destroy');
            $("#location-product-list").empty();
            $("#location-product-list").html(data.html);
            $('select').select2({ theme: 'bootstrap4', width: "50%" });
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
            button.prop("disabled", false);
            button.html("Bekreft");
          }
        })       
    })

    $(document).on('click','.location-product-delete-button',function(e){
        e.preventDefault()
        const locationProductId = $(this).attr("data-location-product-id");
        
        $.ajax({
        type: "POST",
        url: "/api/v1/private/organizer-location-product/remove-product",
        data: { location_product_id: locationProductId,location_id: locationId },
      })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $('select').select2('destroy');
            $("#location-product-list").empty();
            $("#location-product-list").html(data.html);
            $('select').select2({ theme: 'bootstrap4', width: "50%" });
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
          }
        })       
    })

    $(document).on('click','#location-product-template-register-button',function(e){
       e.preventDefault()
       const templateId = $(".location-product-template-select").val();
       const button = $(this);
       const buttonWidth = button.outerWidth();

       button.css("width", buttonWidth + "px");
       button.prop("disabled", true);
       button.html('<i class="spinner-border spinner-border-sm"></i>');

        $.ajax({
        type: "POST",
        url: "/api/v1/private/organizer-location-product/add-location-product-template",
        data: { template_id: templateId,location_id: locationId },
        })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $('select').select2('destroy');
            $("#location-product-list").empty();
            $("#location-product-list").html(data.html);
            $('select').select2({ theme: 'bootstrap4', width: "50%" });
            button.prop("disabled", false);
            button.html('Legg til produktmal');
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
            button.prop("disabled", false);
            button.html('Legg til produktmal');
          }
        })       
    })
  }

  if(p==="organizer_location_product_template"){
    $('select').select2({theme: 'bootstrap4',width:"50%"});

    let organizerId = $("body").attr("organizer_id");
    $(document).on('click', '.product-template-item', function(e) {
        window.location.href = $(this).data('href');
    });

    $(document).on('click', '#new-product-template', function(e) {
        $("#product-template-name").val('');
        $("#product-template-confirm-btn").attr('data-template-id','');
        $("#product-template-modal").modal('show');
    });

    $(document).on('click', '.product-template-item-update', function(e) {
        e.stopPropagation();
        const templateId = $(this).attr('data-template-id');
        const templateName = $(this).attr('data-template-name');
        $("#product-template-confirm-btn").attr('data-template-id',templateId);
        $("#product-template-name").val(templateName);
        $("#product-template-modal").modal('show');
        
    });

    $(document).on('click', '#product-template-confirm-btn', function(e) {
        e.preventDefault()
        const templateName = $("#product-template-name").val();
        const templateId = $(this).attr('data-template-id');
        const button = $(this);
        let url= '';

        if(templateId){
            url = "/api/v1/private/organizer-location-product/update-product-template"
        }else{
            url = "/api/v1/private/organizer-location-product/create-product-template"
        }
        
        button.prop("disabled", true);
        button.html('<div class="loader"></div>');

        $.ajax({
        type: "POST",
        url,
        data: { 
            template_name: templateName,
            template_id:templateId,
            organizer_id:organizerId 
        },
        })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $('#product-template-list').empty();
            $('#product-template-list').html(data.html);
            $("#product-template-modal").modal('hide');
          }
          button.prop("disabled", false);
          button.html("Bekreft");
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
            button.prop("disabled", false);
            button.html("Bekreft");
          }
        });
    });
        
    $(document).on('click', '.product-template-item-delete', function(e) {
        e.preventDefault();
        e.stopPropagation();
        const templateId = $(this).attr('data-template-id');
        const button = $(this);
        
        button.prop("disabled", false);
        button.html('<div class="loader"></div>');

        $.ajax({
        type: "POST",
        url:"/api/v1/private/organizer-location-product/delete-product-template",
        data: { 
            template_id:templateId,
            organizer_id:organizerId 
        },
        })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $('#product-template-list').empty();
            $('#product-template-list').html(data.html);
            $("#product-template-modal").modal('hide');
          }
          button.prop("disabled", true);
          button.html("Bekreft");
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
            button.prop("disabled", false);
            button.html("Bekreft");
          }
        })    
    });

  }

   if(p==="organizer_location_product_template_product"){
    $('select').select2({theme: 'bootstrap4',width:"50%"});

    let locationId = $("body").attr("evnet_id");
    let templateId = $("body").attr("template_id");
    let organizerId = $("body").attr("organizer_id");

    $(document).on('click','#template-product-link-register-button',function(e){
        e.preventDefault()
        const productId = $(".location-product-select").val();
        
        $.ajax({
        type: "POST",
        url: "/api/v1/private/organizer-location-product/add-product-template-product",
        data: { template_id: templateId,product_id:productId ,organizer_id:organizerId},
      })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $('select').select2('destroy');
            $("#location-product-list").empty();
            $("#template-product-list").html(data.html);
            $('select').select2({ theme: 'bootstrap4', width: "50%" });
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
            button.prop("disabled", false);
            button.html("Bekreft");
          }
        })       
    });

    $(document).on('click','.product-template-link-delete-button',function(e){
        e.preventDefault()
        const productTemplateLinkId = $(this).attr('data-template-product-link-id');
        
        $.ajax({
        type: "POST",
        url: "/api/v1/private/organizer-location-product/remove-product-template-product",
        data: { product_template_link_id: productTemplateLinkId,
            organizer_id: organizerId,
            template_id:templateId
        },
      })
        .done(function (data) {
          if (data && data.success && data.html) {
            popupAlert();
            $('select').select2('destroy');
            $("#location-product-list").empty();
            $("#template-product-list").html(data.html);
            $('select').select2({ theme: 'bootstrap4', width: "50%" });
          }
        })
        .fail(function (data) {
          if (
            data.responseJSON.error_message !== undefined &&
            data.responseJSON.error_message !== null
          ) {
            showToast({
              title: "Feil!",
              message: data.responseJSON.error_message,
              type: "error",
              duration: 3000,
              position: "bottom-right",
            });
            button.prop("disabled", false);
            button.html("Bekreft");
          }
        })       
    })
   };
})